import ApiHandler from "./ApiHandler";

const Appeal = {
  deleteDecision: async (appealId) => await ApiHandler.i.auth().delete(`/appeal/${appealId}/decision`),
  findAll: async (query) => await ApiHandler.i.auth().get(`/appeal/find-all?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/appeal/find-one?${query.toString()}`),
  getCount: async (query) => await ApiHandler.i.auth().get(`/appeal/count?${query.toString()}`),
  getOne: async (appealId) => await ApiHandler.i.auth().get(`/appeal/${appealId}`),
  getReportFile: async (query) => await ApiHandler.i.auth().get(`/appeal/report-file?${query.toString()}`),
  getReview: async (query) => await ApiHandler.i.auth().get(`/appeal/review?${query.toString()}`),
  postOne: async (data, options) => await ApiHandler.i.auth().post('/appeal', data, options),
  putInspect: async (appealId, data, options) => await ApiHandler.i.auth().put(`/appeal/${appealId}/inspect`, data, options),
  putInspector: async (appealId, data, options) => await ApiHandler.i.auth().put(`/appeal/${appealId}/inspector`, data, options),
  putRefuse: async (appealId) => await ApiHandler.i.auth().put(`/appeal/${appealId}/refuse`, {}),
  putTakeOnCheck: async (appealId) => await ApiHandler.i.auth().put(`/appeal/${appealId}/take-on-check`, {}),
};

export default Appeal;